import React, { ComponentProps } from 'react';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';
import { PageMembershipMatchingAttributesDefaultView } from './views/PageMembershipMatchingAttributesDefaultView';
import { PageMembershipMatchingAttributesEditView } from './views/PageMembershipMatchingAttributesEditView';
import { PageMembershipMatchingAttributesInteractions } from './partials/PageMembershipMatchingAttributesInteractions';

export type PageMembershipMatchingAttributesBlockProps = Views<
  DefaultView<PageMembershipMatchingAttributesDefaultView> & OptionalEditView<PageMembershipMatchingAttributesEditView>
>;

function PageMembershipMatchingAttributes(
  { views, activeView = 'default' }: PageMembershipMatchingAttributesBlockProps) {
  const { editModeInfo } = useAppContext();
  const { active } = editModeInfo;
  return active
    ? <PageMembershipMatchingAttributesInteractions views={views} activeView={activeView} />
    : <PageMembershipMatchingAttributesDefaultView {...views.default} />;
}

export const PageMembershipMatchingAttributesBlock =
  asFetchableBlock(PageMembershipMatchingAttributes, BlockType.pagemembershipmatchingattributes);
export type PageMembershipMatchingAttributesBlock = ComponentProps<typeof PageMembershipMatchingAttributesBlock>;
